import Cookies from 'js-cookie';
import Environment from '../Environment';

export const getLastCartCookieName = () => {
  if (Environment.isRunningLocally()) return 'development_last_cart';

  // *_last_cart is a legacy Mononoth cookie used before the basket frontend went live
  // The ENV is based off of the Rails.env and uses `staging` for both QA and staging
  return Environment.isProduction() ? 'production_last_cart' : 'staging_last_cart';
};

const getDomain = () => {
  if (Environment.isRunningLocally()) return null;

  const publicDns = Environment.publicDns();
  return Environment.isQa() ? `.${publicDns.replace(/^public\./, '')}` : `.${publicDns}`;
};

Cookies.defaults = { domain: getDomain() };

export default Cookies;
